import { IApplicationState } from '../../types/redux';

export const getAggregateRating = (state: IApplicationState): number | null | undefined => {
  return state.offersData.seo?.aggregateRating;
};
